import { observer } from "mobx-react";
import { Box } from "@mui/material";

import { useChatCategoryStore } from "../hooks/useChatCategoryStore";
import ContractResearch from "../components/preChats/ContractResearch";
import SidePanelContent from "../components/ui/SidePanelContent";
import Column from "../components/ui/core/Column";
import { useAppStore } from "../hooks/useAppStore";

export const ContractResearchPage = observer(() => {
  // Resetting on mount happens inside ContractResearch, not here — child effects
  // run before parent effects, so clearing here would race the child's initial
  // fetchContracts() (see ContractResearch.tsx's mount effect).
  const { sidePanelWidth } = useChatCategoryStore();
  const { sidebarWidth, contractToPreview } = useAppStore();

  const panelOpen = !!contractToPreview;

  return (
    <main
      id="chat-container-ref"
      className="relative grow flex flex-row bg-hex-gray-100 h-[calc(100%-6rem)]"
      style={{ width: `calc(100vw - ${sidebarWidth}px)` }}
    >
      <Column
        sx={{
          height: "100%",
          width: panelOpen ? `calc(100% - ${sidePanelWidth}%)` : "100%",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
          flexShrink: 0,
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pb: 1.5,
            boxSizing: "border-box",
          }}
        >
          <ContractResearch />
        </Box>
      </Column>

      {panelOpen ? (
        <SidePanelContent
          activePanel="contract"
          position="right"
          editor={{} as any}
          viewer={{} as any}
        />
      ) : null}
    </main>
  );
});
